export default __webpack_public_path__ + "static/media/leader_notes.71562c44.pdf";